import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { useEventListener } from "usehooks-ts";
const KONAMI_SEQUENCE = ["ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a", "Enter"];
export function useKonamiCode(callback, t0) {
  const $ = _c(4);
  const sequence = t0 === undefined ? KONAMI_SEQUENCE : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const buffer = useRef(t1);
  const lastKeyTime = useRef(0);
  let t2;
  if ($[1] !== callback || $[2] !== sequence) {
    t2 = event => {
      if (event.defaultPrevented) {
        return;
      }
      const now = Date.now();
      if (now - lastKeyTime.current > 1000) {
        buffer.current = [];
      }
      lastKeyTime.current = now;
      if (event.key === sequence[buffer.current.length]) {
        buffer.current.push(event.key);
      } else {
        buffer.current = event.key === sequence[0] ? [event.key] : [];
      }
      if (buffer.current.length === sequence.length) {
        buffer.current = [];
        event.preventDefault();
        callback();
      }
    };
    $[1] = callback;
    $[2] = sequence;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEventListener("keydown", t2);
}